<template lang="html">
  <div id="app" class="main column no-header">
    <div class="background-login"></div>
    <div class="login subscribe active maintenance">
      <div class="w-100 text-center">
        <logo />
      </div>
      <div class="heading">
        <h1>Page Introuvable</h1>
        <p>La page que vous demandé est actuellement introuvable</p>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/common/components/Logo.vue'
export default {
	name: 'not-found',
	components: { Logo }
}
</script>



// WEBPACK FOOTER //
// NotFound.vue?b3a4a718